function getColumnTitle(columns, field) {
  var itemIndex = columns.indexOf(
    columns.filter(function(col) {
      return col.field === field
    })[0],
  )
  var column = columns[itemIndex]
  return column.title
}

function getGridColumns(columnsData) {
  var columns = [
    {
      field: 'DealId',
      title: 'DealId',
      hidden: true,
    },
    {
      field: 'ClientId',
      title: 'ClientId',
      hidden: true,
    },
  ]

  columnsData.forEach(function(element) {
    var column = {
      field: element.field,
      title: getColumnTitle(columnsData, element.field),
      headerAttributes: {
        style: 'text-align: center;',
      },
      attributes: {
        style: 'text-align: right;',
      },
      format: '{0:0}',
    }

    switch (column.field) {
      case 'Client':
        column.hidden = true
        break
      case 'TradeDate':
      case 'MaturityDate':
        column.format = '{0:yyyy-MM-dd}'
        column.attributes['style'] = 'text-align: right;'
        break
      case 'Amount':
      case 'UndeliveredAmount':
        column.format = '{0:n0}'
        column.attributes['style'] = 'text-align: right;'
        break
      case 'Rate1':
      case 'Rate2':
        column.format = '{0:n4}'
        column.attributes['style'] = 'text-align: right;'
        break
      default:
        break
    }
    columns.push(column)
  })

  return columns
}

function renderGrid($container, options, renderLocation) {
  return new Promise(function(resolve, reject) {
    var columnsDataSource = new kendo.data.DataSource({
      transport: {
        read: {
          url: '/api/report/LastNext/LastNextTransactionGridColumnsDataSource',
          type: 'GET',
          cache: false,
          data: function() {
            return {
              clientId: options.clientId,
            }
          },
          error: function(error) {
            reject(error)
          },
        },
      },
    })

    columnsDataSource.fetch().then(function() {
      var columnsData = columnsDataSource.data()

      var readUrl =
        renderLocation === 'report'
          ? '/api/report/LastNext/LastNextTransactionGridDataSourceRead'
          : '/api/report/LastNext/LastNextTransactionGridDashboardDataSourceRead'

      $container
        .empty()
        .kendoGrid({
          editable: false,
          scrollable: false,
          dataSource: {
            transport: {
              read: {
                url: readUrl,
                type: 'GET',
                cache: false,
                data: function() {
                  if (renderLocation === 'report') {
                    return {
                      asOfDate: options.asOfDate,
                      fromDate: options.fromDate,
                      toDate: options.toDate,
                      sectorId: options.sectorId,
                      divisionId: options.divisionId,
                      ccyPairId: options.ccyPairId,
                      isHistorical: options.isHistorical,
                      clientId: options.clientId,
                      optionValue: +options.optionValue,
                    }
                  }
                  if (renderLocation === 'dashboard') {
                    return {
                      asOfDate: options.asOfDate,
                      nbMonths: options.nbMonths,
                      sectorId: options.sectorId,
                      ccyPairId: options.ccyPairId,
                      clientId: options.clientId,
                    }
                  }
                },
              },
            },
            schema: {
              errors: 'errors',
              total: 'total',
              data: 'data',
              model: {
                id: 'DealId',
                fields: {
                  DealId: {field: 'dealId', type: 'number'},
                  Client: {field: 'client', type: 'string'},
                  TradeDate: {field: 'tradeDate', type: 'date'},
                  MaturityDate: {field: 'maturityDate', type: 'date'},
                  BuySell: {field: 'buySell', type: 'string'},
                  Product: {field: 'product', type: 'string'},
                  Amount: {field: 'amount', type: 'number'},
                  Ccy: {field: 'ccy', type: 'string'},
                  Rate1: {field: 'rate1', type: 'number'},
                  Rate2: {field: 'rate2', type: 'number'},
                  Counterparty: {field: 'counterparty', type: 'string'},
                  UndeliveredAmount: {field: 'undeliveredAmount', type: 'number'},
                },
              },
            },
          },
          filterable: false,
          sortable: false,
          pageable: false,
          dataBound: function(e) {
            if (renderLocation === 'dashboard') {
              var items = e.sender.dataSource.data().length
              if (items == 0) {
                e.sender.element.closest('.component').remove()
              }
              if (items > 25) {
                e.sender.element.closest('.component').prepend('<div class="page-break"/>')
              }
            }

            resolve()
          },
          columns: getGridColumns(columnsData),
        })
        .data('kendoGrid')

      // if (renderLocation === 'report') {
      //   kgAutoheight.enableResize($container.data('kendoGrid'))
      // }
    })
  })
}

function refreshGrid($container) {
  return new Promise(function(resolve) {
    var grid = $container.data('kendoGrid')
    grid.dataSource.read().then(function() {
      resolve()
    })
  })
}

export default {
  render: function($container, options, location = 'dashboard') {
    return renderGrid($container, options, location)
  },
  refresh: function($container, options) {
    return refreshGrid($container, options, 'report')
  },
}
